<template>
  <a-range-picker
    :value="value"
    :placeholder="[placeholder, placeholder]"
    :onChange="dataChange"
    :style="{ width: props.width }"
    :disabled-date="setDisabledDate"
    v-if="!props.disabled"
  />
  <span class="comValue" v-else>{{ comValue }}</span>
</template>

<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import dayjs from 'dayjs'

  const emit = defineEmits()

  const props = defineProps({
    start: {
      required: true, //是否必传
    },
    end: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    'allow-clear': {
      default: false,
    },
    //传入的日期是否是格式化的日期，如2024-1-2,就true
    valueFormat: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    defaultPickerValue: {
      default: false,
    },
    width: {
      default: '100%',
    },
    disabledDate: {
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  })
  const comValue = computed(() => {
    const format = props.format || 'YYYY-MM-DD HH:mm:ss'
    if (props.start && props.end) {
      return `${dayjs(props.start).format(format)} 至 ${dayjs(props.end).format(format)}`
    }
    return '-'
  })
  const placeholder = props?.placeholder
    ? props?.label?.placeholder
    : `请选择${props?.label}`

  const value = computed(() => {
    if (props.valueFormat) {
      if (props.start && props.end) {
        return [dayjs(props.start), dayjs(props.end)]
      }
      if (props.defaultPickerValue) {
        return [
          dayjs(props.defaultPickerValue),
          dayjs(props.defaultPickerValue),
        ]
      }
      return []
    } else {
      return [props.start, props.end]
    }
  })

  function dataChange(data) {
    if (!data) {
      emit('update:start', undefined)
      emit('update:end', undefined)
    } else if (props.valueFormat) {
      emit('update:start', data[0].format(props.format))
      emit('update:end', data[1].format(props.format))
    } else {
      emit('update:start', data[0])
      emit('update:end', data[1])
    }
  }

  function setDisabledDate(current) {
    return props?.disabledDate && props.disabledDate(current, dayjs)
  }
</script>

<style lang="less" scoped></style>
